import React, { useState, useEffect } from 'react'
import ExamHeadHeader from '../common/ExamHeadHeader'
import Footer from '../common/Footer'
import { baseUrl } from '../../Utility/constants'
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { getSchoolId } from '../../Utility/commonFunctions';

const GradeMaster = () => {
  const standardApiUrl = `${baseUrl}/api/StandardMaster/GetStandardBySchool`;

  const [subjects, setSubjects] = useState([]);
  const [data, setData] = useState([]);
  const [schoolId, setSchoolId] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [standards, setStandards] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const [formData, setFormData] = useState({
    id: 0,
    standardId: "",
    subjectId: "",
    rangeFrom: "",
    rangeTo: "",
    gradeName: "",
    status: "",
    finalTheory:0 ,
    finalOral: 0,
    finalJournal: 0,
    finalProject: 0,
    finalPractical: 0,
    createdBy: localStorage.getItem("userID"),
    updatedBy: localStorage.getItem("userID"),
    createdOn: new Date().toISOString(),
    updatedOn: new Date().toISOString(),
    isActive: true,
  });

  const clearForm = () => {
    setFormData({
      id: 0,
      standardId: "",
      subjectId: "",
      rangeFrom: "",
      rangeTo: "",
      gradeName: "",
      status: "",
      finalTheory:0 ,
    finalOral: 0,
    finalJournal: 0,
    finalProject: 0,
    finalPractical: 0,
      createdBy: localStorage.getItem("userID"),
      updatedBy: localStorage.getItem("userID"),
      createdOn: new Date().toISOString(),
      updatedOn: new Date().toISOString(),
      isActive: true,
    });
  }

  useEffect(() => {
    fetchData();
    const loadSchoolId = async () => {
      try {
        const school = await getSchoolId();
        if (school !== null && school !== undefined) {
          setSchoolId(school);
        }
      } catch (error) {
        console.error("Error loading school ID", error);
      }
    };
    loadSchoolId();
  }, []);

  const openAddModal = () => {
    setEditingId(null);
    clearForm();
    setModalOpen(true);
  };

  const openEditModal = (item) => {
    setEditingId(item.id);
    setModalOpen(true);
    fetchDataById(item.id);
  };

  const fetchDataById = async (teacherId) => {
    try {
      const response = await axios.get(`${baseUrl}/api/GradeMaster/${teacherId}`);
      const data = response.data;

      // Ensure subjects & sections are loaded first
      await Promise.all([
        axios.get(`${baseUrl}/api/SubjectMaster/GetSubjectsByClass?classId=${data.standardId}`)
          .then(res => setSubjects(res.data))
      ]);

      // Now set the form data
      setFormData({
        ...data,
        subjectId: data.subjectId?.toString(), 
        createdBy: localStorage.getItem("userID"),
        updatedBy: localStorage.getItem("userID"),
        createdOn: new Date().toISOString(),
        updatedOn: new Date().toISOString(),
      });
    } catch (error) {
      toast.error("Error fetching teacher mapping data");
      console.error(error);
    }
  };


  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    setFormData((prev) => ({
      ...prev,
      //[e.target.name]: e.target.value,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      try {
        await axios.delete(`${baseUrl}/api/GradeMaster/${id}`);
        toast.success("Deleted successfully");
        fetchData();
        clearForm();
      } catch (error) {
        toast.error("Failed to delete");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        schoolId: schoolId,
        createdOn: new Date().toISOString(),
        updatedOn: new Date().toISOString(),
        createdBy: localStorage.getItem("userID"),
        updatedBy: localStorage.getItem("userID"),
        isActive: true,
      };

      if (editingId) {
        await axios.put(`${baseUrl}/api/GradeMaster/${editingId}`, payload);
        toast.success("Details updated successfully");
      } else {
        await axios.post(`${baseUrl}/api/GradeMaster`, payload);
        toast.success("Details added successfully");
      }

      setModalOpen(false);
      fetchData();
      clearForm();
    } catch (error) {
      if (error?.response?.status === 409) {
        toast.error("Details already exist.");
      } else {
        toast.error("Operation failed");
      }
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/GradeMaster`);
      setData(response.data || []);
    } catch (error) {
      toast.error("Error fetching data");
    }
  };

  useEffect(() => {
    if (formData.standardId) {
      fetchSubjects();
    }
    else
      setSubjects([]);
  }, [formData.standardId]);

  // Subject Selection 
  const fetchSubjects = async () => {
    
    try {
      const response = await axios.get(
        `${baseUrl}/api/SubjectMaster/GetSubjectsByClass?classId=${formData.standardId}`
      );
      if (response?.data?.length > 0)
        setSubjects(response.data);
      else
        setSubjects([]);
    } catch (error) {
      console.error("Error fetching subjects", error);
    }
  };

  // Fetch standards based on schoolId
  useEffect(() => {
    if (schoolId) {
      axios
        .get(`${standardApiUrl}?id=${schoolId}`)
        .then((response) => setStandards(response.data))
        .catch(() => console.log("Error fetching standards"));
    }
  }, [schoolId]);

  return (
    <>
      <ExamHeadHeader />
      <div className="container mt-5 mb-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Grade Master</h4>
          <button className="btn btn-primary" onClick={openAddModal}>
            Add New
          </button>
        </div>

        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Standard</th>
              <th>Subject</th>
              <th>RangeFrom </th>
              <th>RangeTo</th>
              <th>Grade</th>
              <th>Status</th>
              <th>Journal</th>
              <th>Project</th>
              <th>Theory</th>
              <th>Practical</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.length ? data.map((item, i) => (
              <tr key={item.id}>
                <td>{i + 1}</td>
                <td>{item.standardName}</td>
                <td>{item.subjectCode} - {item.subjectName}</td>
                <td>
                  {item.rangeFrom}
                </td>
                <td>
                  {item.rangeTo}
                </td>
                <td>
                  {item.gradeName}
                </td>
                <td>{item.status}</td>
                <td>{item.finalJournal}</td>
                <td>{item.finalProject}</td>
                <td>{item.finalTheory}</td>
                <td>{item.finalPractical}</td>
             
                <td>
                  <button className="btn btn-warning btn-sm me-2" onClick={() => openEditModal(item)}>Edit / View</button>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDelete(item.id)}>Delete</button>
                </td>
              </tr>
            )) : <tr><td colSpan="9" className="text-center">No records found</td></tr>}

          </tbody>
        </table>


        {/* Modal */}
        {modalOpen && (

          <div
            className="modal show fade"
            tabIndex="-1"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <form onSubmit={handleSubmit}>
                  <div className="modal-header">
                    <h5 className="modal-title">{editingId ? "Edit Grade" : "Add Grade"}</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setModalOpen(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    {/* Standard & Subject Dropdowns */}
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Standard</label>
                        <select
                          className="form-select"
                          name="standardId"
                          value={formData.standardId}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Standard</option>
                          {standards.map((std) => (
                            <option key={std.id} value={std.id}>
                              {std.standardName}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold">Subject</label>
                        <select
                          className="form-select"
                          name="subjectId"
                          value={formData.subjectId}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Subject</option>
                          {subjects.map((sub) => (
                            <option key={sub.subjectId} value={sub.subjectId}>
                              {sub.subjectName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Range From - To */}
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Range From</label>
                        <input
                          type="number"
                          className="form-control"
                          name="rangeFrom"
                          value={formData.rangeFrom}
                          onChange={handleInputChange}
                          placeholder="Enter starting range"
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold">Range To</label>
                        <input
                          type="number"
                          className="form-control"
                          name="rangeTo"
                          value={formData.rangeTo}
                          onChange={handleInputChange}
                          placeholder="Enter ending range"
                        />
                      </div>
                    </div>

                    {/* Grade & Status */}
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Grade</label>
                        <input
                          type="text"
                          className="form-control"
                          name="gradeName"
                          value={formData.gradeName}
                          onChange={handleInputChange}
                          placeholder="Grade Name"
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold">Status</label>
                        <input
                          type="text"
                          className="form-control"
                          name="status"
                          value={formData.status}
                          onChange={handleInputChange}
                          placeholder="Status"
                        />
                      </div>
                    </div>

                    {/* Final Marks */}
                    <div className="row mb-3">
                    <div className="col-md-6 col-lg-3 mb-2">
                        <label className="form-label fw-bold">Journal Marks</label>
                        <input
                          type="number"
                          className="form-control"
                          name="finalJournal"
                          value={formData.finalJournal}
                          onChange={handleInputChange}
                          placeholder="Journal"
                        />
                      </div>
                      <div className="col-md-6 col-lg-3 mb-2">
                        <label className="form-label fw-bold">Project Marks</label>
                        <input
                          type="number"
                          className="form-control"
                          name="finalProject"
                          value={formData.finalProject}
                          onChange={handleInputChange}
                          placeholder="Project"
                        />
                      </div>
                      <div className="col-md-6 col-lg-3 mb-2">
                        <label className="form-label fw-bold">Theory Marks</label>
                        <input
                          type="number"
                          className="form-control"
                          name="finalTheory"
                          value={formData.finalTheory}
                          onChange={handleInputChange}
                          placeholder="Theory"
                        />
                      </div>          
                      <div className="col-md-6 col-lg-3 mb-2">
                        <label className="form-label fw-bold">Practical Marks</label>
                        <input
                          type="number"
                          className="form-control"
                          name="finalPractical"
                          value={formData.finalPractical}
                          onChange={handleInputChange}
                          placeholder="Practical"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button type="submit" className="btn btn-success">
                      {editingId ? "Update" : "Add"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setModalOpen(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
      <Footer />
    </>
  )
}

export default GradeMaster